module.exports = __webpack_public_path__ + "static/media/report.a8d95c92.svg";